// extracted by mini-css-extract-plugin
export var columnList = "_ep-0";